import { render, staticRenderFns } from "./TestAnimate.vue?vue&type=template&id=1afa06f6&scoped=true&"
var script = {}
import style0 from "./TestAnimate.vue?vue&type=style&index=0&id=1afa06f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afa06f6",
  null
  
)

export default component.exports